import React, { useState } from 'react';
import ToolCard from '../../components/ToolCard';
import toolsData from '../../data/ai_tools_100.json';
import PageLayout from '../../components/PageLayout';

const AITools =  () => {
  const [selectedCategory, setSelectedCategory] = useState('All');

  // Get all unique categories
  const categories = ['All', ...toolsData.map(item => item.category)];

  // Filter tools based on selected category
  const getFilteredTools = () => {
    if (selectedCategory === 'All') {
      return toolsData.flatMap(item => item.tools);
    }
    const categoryData = toolsData.find(item => item.category === selectedCategory);
    return categoryData ? categoryData.tools : [];
  };

  const filteredTools = getFilteredTools();

  return (
    <PageLayout>
    <div style={styles.container}>
      <div style={styles.header}>
        <h1 style={styles.heading}>🤖 AI Tools Directory</h1>
        <p style={styles.subheading}>
          Discover the best AI tools for content creators and businesses
        </p>
      </div>

      {/* Category Filter */}
      <div style={styles.filterSection}>
        <h3 style={styles.filterTitle}>Filter by Category</h3>
        <div style={styles.categoryButtons}>
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setSelectedCategory(category)}
              style={{
                ...styles.categoryBtn,
                ...(selectedCategory === category ? styles.categoryBtnActive : {})
              }}
            >
              {category}
            </button>
          ))}
        </div>
      </div>

      {/* Tools Grid */}
      <div style={styles.toolsCountSection}>
        <p style={styles.toolsCount}>
          Showing <strong>{filteredTools.length}</strong> tool{filteredTools.length !== 1 ? 's' : ''}
        </p>
      </div>

      <div style={styles.grid}>
        {filteredTools.length > 0 ? (
          filteredTools.map((tool, index) => (
            <ToolCard key={index} tool={tool} />
          ))
        ) : (
          <div style={styles.noResults}>
            <p>No tools found for this category.</p>
          </div>
        )}
      </div>
    </div>
    </PageLayout>
  );
}

export default AITools;


const styles = {
  container: {
    padding: '40px 20px',
    maxWidth: '1400px',
    margin: '0 auto',
    fontFamily: 'Arial, sans-serif',
    backgroundColor: '#f9f9f9',
    borderRadius: '8px',
    width: '100%',
    boxSizing: 'border-box',
  },
  header: {
    textAlign: 'center',
    marginBottom: '40px',
  },
  heading: {
    fontSize: 'clamp(2rem, 5vw, 2.8rem)',
    color: '#2c3e50',
    marginBottom: '10px',
    wordBreak: 'break-word',
  },
  subheading: {
    fontSize: 'clamp(1rem, 3vw, 1.2rem)',
    color: '#7f8c8d',
    marginBottom: '0',
    wordWrap: 'break-word',
  },
  filterSection: {
    marginBottom: '40px',
    textAlign: 'center',
  },
  filterTitle: {
    fontSize: '1.3rem',
    color: '#2c3e50',
    marginBottom: '15px',
  },
  categoryButtons: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: '10px',
  },
  categoryBtn: {
    padding: '8px 16px',
    border: '2px solid #3498db',
    backgroundColor: '#fff',
    color: '#3498db',
    borderRadius: '25px',
    cursor: 'pointer',
    fontSize: '0.95rem',
    fontWeight: '500',
    transition: 'all 0.3s',
    whiteSpace: 'nowrap',
  },
  categoryBtnActive: {
    backgroundColor: '#3498db',
    color: '#fff',
  },
  toolsCountSection: {
    display: 'none', // Hidden by default, but you can show it if needed
    marginBottom: '20px',
    textAlign: 'center',
  },
  toolsCount: {
    fontSize: '1rem',
    color: '#7f8c8d',
    margin: '0',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
    gap: '20px',
  },
  noResults: {
    gridColumn: '1 / -1',
    textAlign: 'center',
    padding: '40px 20px',
    color: '#7f8c8d',
    fontSize: '1.1rem',
  },
};